/**
 * 军师等待指示器 —— 0921 老板:「响应这么慢的话,先做一个假的加载动效,SSE 先不做」。
 *
 * ★为什么要有:军师一轮回复是**整轮返回**的(`advisorChatApi.chat` await 到底,不流式),
 *   慢的时候十几二十秒。此前这段时间页面上只有一行静态小字「军师思考中…」,
 *   和「卡死了」长得一模一样 —— 用户会去点第二次、或者直接走。
 * ★「假」在哪:三点跳动 + 按**已等时长**轮换提示语,与后端真实进度**无关**。
 *   所以提示语只许说「在想 / 还在想 / 快好了」这类不可能为假的话,**不许**写
 *   「正在读你的资料 / 正在检索知识库」—— 它不知道后端此刻在干什么,谎报具体步骤
 *   会在某一轮根本没用知识库的时候被用户当场戳穿。真进度等 SSE 那一版再说。
 * ★形态对齐军师的回复(左规线,不是气泡)—— 它占的就是回复将要出现的那个位置。
 * ★企微 H5 那边(`wecom-h5/advisor/AdvisorChat.tsx`)早有 GSAP 的三点波浪;这里用纯 CSS,
 *   不为一个等待态给控制台多拉一个动画库。
 */
import { useEffect, useState } from "react";

import { cn } from "@/shared/lib/utils";

import { thinkingHintFor } from "../model/thinkingHint";

export function ThinkingIndicator({ name, className }: { name?: string; className?: string }) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const startedAt = Date.now();
    const id = window.setInterval(() => {
      setElapsed(Math.floor((Date.now() - startedAt) / 1000));
    }, 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "my-3 flex items-center gap-2.5 border-l-2 border-primary/50 pl-4 text-sm text-muted-foreground",
        className
      )}
    >
      <span className="inline-flex items-end gap-1" aria-hidden>
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            data-dot
            className="h-1.5 w-1.5 rounded-full bg-primary/70 motion-safe:animate-bounce"
            style={{ animationDelay: `${i * 140}ms`, animationDuration: "900ms" }}
          />
        ))}
      </span>
      <span>{thinkingHintFor(elapsed, name)}</span>
    </div>
  );
}
